import $ from "jquery";
import 'select2';

if( $('.TheHeader').hasClass('TheHeaderResponsive') ) {
    function removeSmall() {
        var element = document.getElementById("headerstick");
        element.classList.remove("smallHeader");
    }

    function addSmall() {
        var element = document.getElementById("headerstick");
        element.classList.add("smallHeader");
    }

    window.onscroll = function() {scrollFunction()};

    function scrollFunction() {
        if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
            addSmall();
        } else {
            removeSmall();
        }
    }
}

if($('.resources-filter').hasClass('active-filters')) {
    $('.select2_topics, .select2_contenttype, .sort_by').select2({
        minimumResultsForSearch: -1
    });
    $('.select2_topics').data('select2').$dropdown.addClass("resources-filter__dropdown");
    $('.select2_contenttype ').data('select2').$dropdown.addClass("resources-filter__dropdown");
    $('.sort_by').data('select2').$dropdown.addClass("resources-filter__dropdown");
}

$(".js-toggleResponsiveMenu").on("click", function(){
    $(".TheHeader-nav").delay(1000).stop().fadeToggle();
});